import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { orangeVIcon, Loader, doubleVIvon } from "../../assets/images/index";
import { RouterConstant } from "../../routers/index";
import { useNavigate } from "react-router-dom";
import { useLayoutContext } from "../../layouts/general-layout";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./carousel.scss";

export interface ExerciseHistoryResponseItem {
  exercise_id: number;
  topic: string;
  last_modified?: string;
  is_completed: boolean;
}

interface CarouselProps {
  items: ExerciseHistoryResponseItem[];
}

const Carousel: React.FC<CarouselProps> = ({ items }) => {
  const navigate = useNavigate();
  const { ROUTERS_PATH } = RouterConstant;
  const { t } = useLayoutContext(); 
  const [showTooltip, setShowTooltip] = useState<number | null>(null);

  if (!items.length) {
    return <div className="loaderBlock">{t("thinking")}...<img src={Loader} alt="Loading" /></div>;
  }

  const handleDisplayExercise = (exerciseId: number) => {
    navigate(ROUTERS_PATH.DISPLAYEXERCISE, { state: { exerciseId: exerciseId, from: "choose-exercise-with-history" } });
  }

  return (
    <div className="slider-container">
      <Swiper className="task-slider"
        modules={[Navigation, Pagination]}
        navigation={items.length > 2} 
        spaceBetween={16}
        loop={false}
        slidesPerView={2.5}
        slidesPerGroup={2}
        centeredSlides={false}
        grabCursor
        observer={true}
        observeParents={true}
        watchOverflow={true}
        breakpoints={{
          640: {
            slidesPerView: 2.5,
            slidesPerGroup: 2,
            slidesOffsetBefore: 16,
            slidesOffsetAfter: 16,
          },
        }}
      >
        {items.map((exercise) => (
          <SwiperSlide key={exercise.exercise_id}>
            <div className="task-card">
              <div className="task-card-date-box">
                <span className="task-card-date">{exercise.last_modified
                    ? new Date(exercise.last_modified).toLocaleDateString("he-IL")
                    : "—"}
                </span>
                <span className="task-card-date-icon">
                  <img
                    src={exercise.is_completed ? doubleVIvon : orangeVIcon}
                    alt={exercise.is_completed ? "Completed" : "In Progress"}
                  />
                </span>
              </div>
              <div
                onMouseEnter={() => setShowTooltip(exercise.exercise_id)}
                onMouseLeave={() => setShowTooltip(null)}
              >
                <h3 className="task-card-title">
                  {exercise.topic}
                </h3>
                {showTooltip === exercise.exercise_id && (
                  <div className="exercise-history-tooltip">
                    {exercise.topic}
                  </div>
                )}
              </div>
              <p
                onClick={() => handleDisplayExercise(exercise.exercise_id)}
                className={`mt-2 task-card-button font-bold ${
                  exercise.is_completed ? "text-green-600" : "text-orange-500"
                }`}
              >
                {t("forExercise")}
              </p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
